import { createApiClient } from "../shared/lib/createApiClient"

const api = createApiClient()

export const getSiteConfig = async () => {
    const { data } = await api.get("/api/site-config")
    return data
}
